<ng-container *ngIf="awardsCountryData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="awardsCountryData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div class="TableTitle TableTitle--withFlag">
    <h2 class="Country">Country</h2>
    <h1><a (click)="analyticsService.pushTitleClickEvent()" routerLink='/awards/'>Awards</a> in {{ awardsCountryData.country.name }}</h1>
    <img *ngIf="countryData" class="Flag" [src]="getImageUrl(awardsCountryData.country.code)" alt="Flag of {{ awardsCountryData.country.name }}"/>
  </div>
  <ul class="Accordeon">
    <li [class.NoArrow]="hideAccordionArrow(awardsCountryData.country)" *ngIf="countryData">
      <header 
        [class.Active]="isActiveAccordion('CountryFacts')" 
        (click)="onClickAccordion('CountryFacts')"
      >
        <h2>Country facts</h2>
      </header>
      <div class="Accordeon-content" [class.DisplayNone]="!isActiveAccordion('CountryFacts')">
        <table class="BasicResponsiveTable">
          <thead>
            <tr>
              <th scope="col">List of operators</th>
              <th scope="col" [class.DisplayNone]="!countryData.capital">Capital</th>
              <th scope="col" [class.DisplayNone]="!countryData.area">Area (km<sup>2</sup>)</th>
              <th scope="col" [class.DisplayNone]="!countryData.population">Population</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-th="List of operators">
                <span *ngFor="let operator of awardsCountryData.operators; last as isLast;">
                  <span style="display: inline-block;">{{ operator }}<span *ngIf="!isLast">,&nbsp;</span></span>
                </span>
              </td>
              <td data-th="Capital" [class.DisplayNone]="!countryData.capital">
                {{ countryData.capital }}
              </td>
              <td data-th="Area (km²)" [class.DisplayNone]="!countryData.area">
                {{ countryData.area | number }}
              </td>
              <td data-th="Population" [class.DisplayNone]="!countryData.population">
                <span [innerHTML]="changePopulationFormat(countryData.population)"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>
    <li [class.DisplayNone]="hideSpectrumAuthority(awardsCountryData.country)">
      <header 
        [class.Active]="isActiveAccordion('SpectrumAuthority')" 
        (click)="onClickAccordion('SpectrumAuthority')"
      >
        <h2>Spectrum profile</h2>
      </header>
      <div class="Accordeon-content" [class.DisplayNone]="!isActiveAccordion('SpectrumAuthority')">
        <table class="BasicResponsiveTable">
          <thead>
            <tr>
              <th scope="col" [class.DisplayNone]="!awardsCountryData.country.authority">Authority</th>
              <th scope="col" [class.DisplayNone]="!awardsCountryData.country.legalBasis">Legal basis</th>
              <th scope="col" [class.DisplayNone]="!awardsCountryData.country.allocationTable">Allocation table</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-th="Authority" [class.DisplayNone]="!awardsCountryData.country.authority">
                <div class="RichText" [innerHtml]="awardsCountryData.country.authority | forceTarget"></div>
              </td>
              <td data-th="Legal basis" [class.DisplayNone]="!awardsCountryData.country.legalBasis">
                <div class="RichText" [innerHtml]="awardsCountryData.country.legalBasis | forceTarget"></div>
              </td>
              <td data-th="Allocation table" [class.DisplayNone]="!awardsCountryData.country.allocationTable">
                <div class="RichText" [innerHtml]="awardsCountryData.country.allocationTable | forceTarget"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>
    <li [class.DisplayNone]="!awardsCountryData.country.countryOutlook">
      <header 
        [class.Active]="isActiveAccordion('CountryOutlook')" 
        (click)="onClickAccordion('CountryOutlook')"
      >
        <h2>Policy outlook</h2>
      </header>
      <div class="Accordeon-content" [class.DisplayNone]="!isActiveAccordion('CountryOutlook')">
        <div class="RichText" [innerHtml]="awardsCountryData.country.countryOutlook | forceTarget"></div>
      </div>
    </li>
  </ul>
  <table class="table ResponsiveTable ResponsiveTable--withHeaderMobile" *ngIf="awardsCountryData.awards.length > 0" datatable [dtOptions]="dtOptions">
    <thead class="AnimatedThead">
      <tr>
        <th scope="col">Award</th>
        <th scope="col">Title</th>
        <th scope="col">Status</th>
        <th scope="col">
          MHz awarded<br>
          <span>(in total)</span>
        </th>
        <th scope="col">
          Price paid<br>
          <span>(in total)</span>
        </th>
        <th scope="col">Price/MHz</th>
        <th scope="col">Price/MHz/pop.</th>
        <th scope="col">Cullen report</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of awardsCountryData.awards">
        <td data-th="Award" [class.EmptyCell]="!row.awardKey">
          <a [routerLink]="'/awards/'+row.awardKey">{{ row.awardKey | delete2FirstChar }}</a>
        </td>
        <td data-th="Title" [class.EmptyCell]="!row.shortTitle">
          {{ row.shortTitle }}
        </td>
        <td data-th="Status" [class.EmptyCell]="hideStatus(row)">
          <div *ngIf="row.status">{{ row.status }}</div>
          <!-- LIGHT COMMENT -->
          <div *ngIf="row.statusComment && row.statusComment != 'BLUR_COMMENT'" class="RichText" [innerHtml]="row.statusComment | forceTarget" [class.DisplayNone]="row.statusComment.length===1"></div>
        </td>
        <td data-th="MHz awarded (total)" [class.EmptyCell]="!row.priceDetails.mhzAwarded" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.mhzAwarded)" [attr.data-order]="row.priceDetails.mhzAwardedOrder">
          <!-- LIGHT CONTENT -->
          <span [innerHtml]="isSpectrumLightContent(row.priceDetails.mhzAwarded)"></span>
        </td>
        <ng-container *ngIf="currencyService.isEuro()">
          <td data-th="Price paid (in band)" [class.EmptyCell]="!row.priceDetails.pricePaid.priceEUR" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePaid.priceEUR)" [attr.data-order]="row.priceDetails.pricePaid.priceOrderEUR">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePaid.priceEUR)"></span>
          </td>
          <td data-th="Price per MHz" [class.EmptyCell]="!row.priceDetails.pricePerMhz.priceEUR" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePerMhz.priceEUR)" [attr.data-order]="row.priceDetails.pricePerMhz.priceOrderEUR">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePerMhz.priceEUR)"></span>
          </td>
          <td data-th="Price per MHz and population" class="NoWrap" [class.EmptyCell]="!row.priceDetails.pricePerMhzPerPerson.priceEUR" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePerMhzPerPerson.priceEUR)" [attr.data-order]="row.priceDetails.pricePerMhzPerPerson.priceOrderEUR">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePerMhzPerPerson.priceEUR)"></span>
          </td>
        </ng-container>
        <ng-container *ngIf="!currencyService.isEuro()">
          <td data-th="Price paid (in band)" [class.EmptyCell]="!row.priceDetails.pricePaid.priceUSD" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePaid.priceUSD)" [attr.data-order]="row.priceDetails.pricePaid.priceOrderUSD">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePaid.priceUSD)"></span>
          </td>
          <td data-th="Price per MHz" [class.EmptyCell]="!row.priceDetails.pricePerMhz.priceUSD" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePerMhz.priceUSD)" [attr.data-order]="row.priceDetails.pricePerMhz.priceOrderUSD">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePerMhz.priceUSD)"></span>
          </td>
          <td data-th="Price per MHz and population" class="NoWrap" [class.EmptyCell]="!row.priceDetails.pricePerMhzPerPerson.priceUSD" [class.HideCellOnMobile]="displayService.hideCellOnMobile(row.priceDetails.pricePerMhzPerPerson.priceUSD)" [attr.data-order]="row.priceDetails.pricePerMhzPerPerson.priceOrderUSD">
            <!-- LIGHT CONTENT -->
            <span [innerHtml]="isSpectrumLightContent(row.priceDetails.pricePerMhzPerPerson.priceUSD)"></span>
          </td>
        </ng-container>
        <td data-th="Cullen report" class="NoWrap" [class.EmptyCell]="row.reports.length===0">
          <div *ngFor="let report of row.reports" class="Loop">
            <a [href]="getDocumentUrl(report.uniqueNumber)" target="fromSpectrum" *ngIf="report.displayName">
              {{ report.displayName | capitalize }}
            </a>
            <a [href]="getDocumentUrl(report.uniqueNumber)" target="fromSpectrum" *ngIf="!report.displayName">
              {{ displayService.displayReportNames(report.uniqueNumber) }}
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="NoResult" *ngIf="awardsCountryData.awards.length===0 && !awardsCountryData.light">
    <p>No award registered in the database</p>
  </div>
  <div class="NoResult" *ngIf="awardsCountryData.awards.length===0 && awardsCountryData.light">
    <p>No award registered in the database or Upgrade your subscription</p>
  </div>
</ng-container>